import './Header.css';
import { HeaderText } from '../Data/Data';
import { useEffect,useState } from 'react';
import { useSelector } from 'react-redux';


const Header = () => {
  const step = useSelector((state) => state.step)
  const [headerInfo, setHeaderInfo] = useState({ title: "", description: "" })

  useEffect(()=>{
    const currentHeader = HeaderText.find((item) => item.id === step);
    if(currentHeader){
      setHeaderInfo({ title: currentHeader.title, description: currentHeader.desc })
    }


  },[step])
  
  return (
    <div className='Header'>
         <h1 className='heading'>{headerInfo.title}</h1>
         <p className='description'>{headerInfo.description}</p>
      
    </div>
  )
}

export default Header
